/*
|--------------------------------------------------------------------------
| App.JS
|
| Import statements must go at the top before any other code
|--------------------------------------------------------------------------
*/

import KeenSlider from '../../components/slider/slider'
import spriteRender from './core/sprite'
import videoControls from './core/video'
import menuInit from './core/menu'
import filtersInit from './core/filters'
import feefoInit from './core/feefo'
import products from './core/products'

spriteRender('smg')

window.addEventListener('DOMContentLoaded', () => {
  videoControls()
  filtersInit()
  products()
  feefoInit()
  menuInit()
})
